import { useState, useEffect } from 'react';

/**
 * Returns a debounced version of the input value. The returned value only
 * updates after the specified delay has elapsed without the input changing.
 * The value is trimmed before being set.
 */
export function useDebouncedValue(value: string, delayMs: number): string {
  const [debounced, setDebounced] = useState(value.trim());

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value.trim()), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
